import "./App.css";
import Header from "./pages/Header";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import About from "./pages/About";
import Footer from "./pages/Footer";
import Works from "./pages/Works";
import Article from "./pages/Article";

function App() {
  return (
    <Router>
      <div className="App">
        <Header />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/works/:id" element={<Article />} />
          <Route path="/works" element={<Works />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
